import {
  Alert,
  Column,
  Columns,
  Stack,
  TextField,
} from "@origin-digital/ods-core";
import React from "react";
import type { FormData, FormErrors } from "./RemoveSupplyPublicForm";

const RequestDetailsForm: React.FC<{
  formData: FormData;
  errors: FormErrors;
  touched: Record<string, boolean>;
  showError: boolean;
  handleJourneyIdChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handlePostcodeChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleJourneyIdBlur: () => void;
  handlePostcodeBlur: () => void;
}> = ({
  formData,
  errors,
  touched,
  showError,
  handleJourneyIdChange,
  handlePostcodeChange,
  handleJourneyIdBlur,
  handlePostcodeBlur,
}) => {
  return (
    <Stack space="large">
      {showError && (
        <Alert tone="critical" title="Oops, those details don't seem to match">
          Please check the details provided in the email/SMS and try again.
        </Alert>
      )}
      {/* Fields */}
      <Stack>
        <TextField
          id="referenceNumber"
          variant="outlined"
          label="Reference number"
          value={formData.journeyId}
          onChange={handleJourneyIdChange}
          onBlur={handleJourneyIdBlur}
          error={Boolean(touched.journeyId && errors.journeyId)}
          helperText={touched.journeyId && errors.journeyId}
        />
        <TextField
          id="postcode"
          variant="outlined"
          label="Postcode"
          value={formData.postcode}
          onChange={handlePostcodeChange}
          onBlur={handlePostcodeBlur}
          error={Boolean(touched.postcode && errors.postcode)}
          helperText={
            <Columns>
              <Column>{touched.postcode && errors.postcode}</Column>
              <Column width="content">{formData.postcode.length}/4</Column>
            </Columns>
          }
        />
      </Stack>
    </Stack>
  );
};

export default RequestDetailsForm;
